import { Button } from '@mui/material';

/**
 * Boton redondeado de CTA.
 *
 * QUE ESTABA MAL
 * --------------
 * 1. Pintaba su color a mano: `backgroundColor: '#03a9f4'` y `color: 'white'`.
 *    Ese azul claro sobre blanco da 2.63:1, por debajo del minimo AA (4.5:1), y
 *    ademas no pertenecia a ninguna paleta de la app: era el unico sitio donde
 *    aparecia.
 *
 * 2. El estado deshabilitado repintaba EL MISMO azul que el habilitado, asi que
 *    un boton apagado se veia identico a uno encendido. En un formulario eso
 *    quita la unica senal de "ya puedes continuar".
 *
 * 3. `':hover'` estaba dentro del prop `style`. React no interpreta
 *    pseudo-selectores en estilos en linea, asi que esa regla nunca se aplico y
 *    el `boxShadow` del hover no existia. Los pseudo-selectores van en `sx`.
 *
 * Ahora no fija ningun color: los pone el tema (`containedPrimary` y su
 * `Mui-disabled`), asi que responde al cambio de claro/oscuro y el estado
 * deshabilitado se distingue de verdad. Aqui solo queda el tamano.
 */
export const RoundedButton = ({ children, sx, style, ...props }: any) => {
  return (
    <Button
      {...props}
      sx={{
        margin: '10px',
        borderRadius: 'var(--radius)',
        boxShadow: 'var(--shadow-sm)',
        /**
         * Se anima solo lo que cambia de verdad. El `transition: all` anterior
         * animaba tambien tamano y posicion, que es lo que provoca saltos.
         */
        transition: 'box-shadow 200ms ease, background-color 200ms ease',
        height: '40px',
        minWidth: '110px',
        '&:hover': {
          boxShadow: 'var(--shadow)',
        },
        /** El `sx` del consumidor gana, para que pueda ajustarlo sin pelear. */
        ...sx,
      }}
      style={style}
    >
      {children}
    </Button>
  );
};
